import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppRoutes } from "./routes";
import { TenantProvider, type TenantConfig } from "./tenants";

// One QueryClient for the whole app. Defaults match the admin-ui drop-ins'
// react-query conventions (15s pending poll on hot queries; everything else
// retries once on transient errors).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App({ tenant }: { tenant: TenantConfig }) {
  return (
    <TenantProvider value={tenant}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        >
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </TenantProvider>
  );
}
